export default __webpack_public_path__ + "static/media/bg1.2e9654b3.jpg";